"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardsMapping = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _ProfileWebsiteActivityTitleWrapper = _interopRequireDefault(require("crm_ui/profile/sidebar/contacts/ProfileWebsiteActivityTitleWrapper"));

var _ProfileWebsiteActivityWrapper = _interopRequireDefault(require("crm_ui/profile/sidebar/contacts/ProfileWebsiteActivityWrapper"));

var _websiteActivityGqlConfig = require("crm_ui/profile/sidebar/contacts/websiteActivityGqlConfig");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _makeAsyncCard = require("../makeAsyncCard");

var _AboutCardTitle = _interopRequireDefault(require("customer-data-sidebar/cards/AboutCard/AboutCardTitle"));

var _gqlConfig = _interopRequireDefault(require("customer-data-sidebar/graphQL/cards/AboutCard/gqlConfig"));

var _getIsUngatedForGraphQL = require("crm_ui/gates/getIsUngatedForGraphQL");

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _CardsAPIConstants = require("crm_ui/sidebar/layouts/CardsAPIConstants");

var _PropertiesCardTitle = _interopRequireDefault(require("crm_ui/profile/sidebar/properties/PropertiesCardTitle"));

var _PropertiesCardContentContainer = _interopRequireDefault(require("crm_ui/profile/sidebar/properties/PropertiesCardContentContainer"));

var _CardsMapping;

var GlobalPropertiesCardConfig = {
  Title: _AboutCardTitle.default,
  Content: (0, _makeAsyncCard.makeAsyncCard)({
    chunkName: 'sidebar-about',
    loader: function loader() {
      return import(
      /* webpackChunkName: "sidebar-about" */
      'crm_ui/profile/sidebar/properties/FavoritePropertiesCardContainer');
    }
  }),
  gqlConfig: (0, _getIsUngatedForGraphQL.getIsUngatedForGraphQL)(_ObjectTypes.default.CONTACT) ? _gqlConfig.default : undefined
};
var PropertiesCardConfig = {
  Title: _PropertiesCardTitle.default,
  Content: _PropertiesCardContentContainer.default
};
var WebsiteActivityCardConfig = {
  Content: _ProfileWebsiteActivityWrapper.default,
  Title: _ProfileWebsiteActivityTitleWrapper.default,
  collapsible: true,
  draggable: true,
  condition: function condition() {
    return _ScopesContainer.default.getContainer().get()['marketing-product-access'];
  },
  gqlConfig: (0, _getIsUngatedForGraphQL.getIsUngatedForGraphQL)(_ObjectTypes.default.CONTACT) ? _websiteActivityGqlConfig.websiteActivityGqlConfig : undefined
};
var GDPRSubscriptionsCardConfig = {
  Content: (0, _makeAsyncCard.makeAsyncCard)({
    chunkName: 'sidebar-gdpr',
    loader: function loader() {
      return import(
      /* webpackChunkName: "sidebar-gdpr" */
      'crm_ui/profile/sidebar/gdpr/GDPRSubscriptionsContainer');
    }
  }),
  Title: function GdprSubscriptionsTitle() {
    return _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "profileSidebarModule.subscriptions.header"
    });
  },
  collapsible: true,
  draggable: true,
  condition: function condition(_ref) {
    var isGdprComplianceEnabled = _ref.isGdprComplianceEnabled;
    return isGdprComplianceEnabled;
  }
};
var CardsMapping = (_CardsMapping = {}, (0, _defineProperty2.default)(_CardsMapping, _CardsAPIConstants.GLOBAL_PROPERTIES_CARD_TYPE, (0, _extends2.default)({}, GlobalPropertiesCardConfig)), (0, _defineProperty2.default)(_CardsMapping, "PROPERTIES", (0, _extends2.default)({}, PropertiesCardConfig)), (0, _defineProperty2.default)(_CardsMapping, "GDPR_SUBSCRIPTIONS", (0, _extends2.default)({}, GDPRSubscriptionsCardConfig)), (0, _defineProperty2.default)(_CardsMapping, "WEBSITE_ACTIVITY", (0, _extends2.default)({}, WebsiteActivityCardConfig)), _CardsMapping);
exports.CardsMapping = CardsMapping;
var _default = [(0, _extends2.default)({}, GlobalPropertiesCardConfig, {
  key: 'Properties'
}), (0, _extends2.default)({}, GDPRSubscriptionsCardConfig, {
  key: 'GDPRSubscriptions'
}), (0, _extends2.default)({}, WebsiteActivityCardConfig, {
  key: 'WebsiteActivity'
})];
exports.default = _default;